export default __webpack_public_path__ + "static/media/bokitas.f4f94186.png";